<app-selector [label]="label" [data]="questionCoreService.questionList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="questionCoreService.loading" [hint]="hint">
</app-selector>